




import {Component, Vue} from 'vue-property-decorator';
import ErrorMessage from '@/components/ErrorMessage.vue';

@Component({components: {
  ErrorMessage,
}})
export default class NotFound extends Vue {
  public errorCode: string = '';

  private beforeCreate() {
  if (this.$gtm.dataLayer()) {
      this.$gtm.dataLayer().push({
        page_type: 'Error',
      });
    }
  }

  private mounted() {
    if (!this.$route.query || !this.$route.query.code) {
      this.$router.replace({ query: { code: this.errorCode || '000'} });
    } else {
      this.errorCode = this.$route.query.code.toString();
    }
  }
}
